/**
 * @file Проверка квоты, доступный остаток, единицы и пороговые цвета.
 *
 * limit и used — накопительные счётчики; доступно сейчас max(0, limit - used).
 * Расчёты не зависят от React и проверяются отдельными тестами.
 */
export interface TrafficQuota {
    limit: number
    used: number
}

export function parseTrafficQuota(data: unknown): TrafficQuota {
    if (
        typeof data !== 'object' ||
        data === null ||
        !('limit' in data) ||
        !('used' in data) ||
        typeof data.limit !== 'number' ||
        typeof data.used !== 'number' ||
        !Number.isSafeInteger(data.limit) ||
        !Number.isSafeInteger(data.used) ||
        data.limit < 0 ||
        data.used < 0
    )
        throw new Error('Invalid traffic quota')

    return { limit: data.limit, used: data.used }
}

export function availableTraffic(quota: TrafficQuota): number {
    return Math.max(0, quota.limit - quota.used)
}

export function trafficLevel(available: number): 'healthy' | 'warning' | 'low' {
    if (available < 1024 ** 3) return 'low'

    if (available < 2 * 1024 ** 3) return 'warning'

    return 'healthy'
}

export function formatTrafficBytes(bytes: number, locale: 'ru' | 'en') {
    const units =
        locale === 'ru'
            ? ['Б', 'КиБ', 'МиБ', 'ГиБ', 'ТиБ', 'ПиБ']
            : ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB']
    let value = bytes
    let index = 0

    while (value >= 1024 && index < units.length - 1) {
        value /= 1024
        index++
    }

    return {
        value: new Intl.NumberFormat(locale, {
            maximumFractionDigits: 1,
        }).format(value),
        unit: units[index],
    }
}
